
import * as XLSX from "xlsx";
import { headerToStringHeader, tableToRowMapper } from "./exportTableToCsv";
import { GenericDataParameters } from "../../../../../Components/Tables/_Tables/useColumnConstructor";
// import { EditDataParameters } from "../../../../../Components/Tables/_Tables/useColumnConstructor";

export const exportTableToExcel = <T,> (data: { [key: string]: any }[], filename: string, worksheetName: string, accessorData: GenericDataParameters<T>[]) => {
  if (!data.length) return;

  const headers = accessorData.map((col) => (headerToStringHeader(col.headerValue))); 
  const rows = data.map((row) => accessorData.map((col) => tableToRowMapper(row, col.accessor)));
  
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  worksheet["!cols"] = accessorData.map(() => ({ wpx: 100 }));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet( workbook, worksheet, worksheetName );
  XLSX.writeFile(workbook, filename);
}